import React from 'react';

import { NativeResources } from '@ariksa/inventory-core';

import { LambdaActivity } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Activity/LambdaActivity';
import { ResourceAPIActivity } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/ResourceAPIActivity';
import { VMActivity } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Compute/VirtualMachine/VMActivity';
import { S3Activity } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Data/ObjectStorage/S3Activity';
import { IAMRoleActivity } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/IAMRole/IAMActivity';
import { IAMUserActivity } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/IAMUser/Activity/IAMUserActivity';

export const getAPIActivity = (resourceType: NativeResources) => {
  switch (resourceType) {
    case NativeResources.SimpleStorageService:
      return <S3Activity />;
    case NativeResources.Ec2Instance:
      return <VMActivity />;
    case NativeResources.IamUser:
    case NativeResources.OktaUser:
      return <IAMUserActivity />;
    case NativeResources.IamRole:
      return <IAMRoleActivity />;
    case NativeResources.LambdaFunction:
      return <LambdaActivity />;
    default:
      return <ResourceAPIActivity />;
  }
};
